import React from "react";
import { useParams } from "react-router-dom";
import { useQueryString } from "./use_query_string";

/**
 * Resolves which HubSpot form to show from query/params and hubspotForms map.
 * Uses fromCatalog (query) or catalogSlug (route param), falls back to "default" key, then hubspotForm.
 */
export function useHubspotFormToUse(
  hubspotForms: { [key: string]: React.ReactNode } | undefined,
  hubspotForm: React.ReactNode | undefined
): React.ReactNode | undefined {
  const { fromCatalog } = useQueryString<{ fromCatalog?: string }>();
  const pageParams = useParams<{ catalogSlug?: string }>();
  const catalogKey = fromCatalog || pageParams.catalogSlug || "default";
  const formFromCatalog = hubspotForms?.[catalogKey];
  return formFromCatalog ? formFromCatalog : hubspotForm;
}
